import DealsApi from "@apis/deals";
import Header from "@commons/header";
import Table from "@components/table";
import Wrapper from "@components/wrapper";
import Button from "@components/button";
import useConfig from "@hooks/useConfig";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Helper from "@utils/helper";
import { useSelector } from "react-redux";

const StoreDealsList = () => {
  const navigate = useNavigate();
  const { bucketUrl } = useConfig();
  const { data: user } = useSelector((state: any) => state.user);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchDeals = async () => {
    setLoading(true);
    try {
      // Fetch all deals for the store's module
      const res: any = await DealsApi.list({
        moduleId: user?.moduleId,
        isActive: true,
      });

      // Also fetch deals the store is already part of to show participation status
      const storeDealsRes: any = await DealsApi.listStoreDeals();
      const storeDealIds = new Set(storeDealsRes.map((sd: any) => sd.dealId));

      if (res) {
        const items = (res.items || res || []).map((deal: any) => ({
          ...deal,
          isParticipating: storeDealIds.has(deal.id),
        }));
        setData(items);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeals();
  }, [user?.moduleId]);

  const columns = [
    {
      title: "SN",
      key: "sn",
      render: (_: any, index: number) => index + 1,
    },
    {
      title: "Title",
      key: "title",
      render: (item: any) => item.title,
    },
    {
      title: "Cover Image",
      key: "coverImage",
      render: (item: any) =>
        item.coverImage ? (
          <img
            src={`${bucketUrl}/${item.coverImage}`}
            alt="deal"
            style={{
              width: 50,
              height: 50,
              objectFit: "cover",
              borderRadius: 4,
            }}
          />
        ) : (
          "No Image"
        ),
    },
    {
      title: "Validity",
      key: "validity",
      render: (item: any) => (
        <div
          style={{
            fontSize: 13,
            display: "flex",
            flexDirection: "column",
            gap: "4px",
          }}
        >
          <div>
            <span style={{ fontWeight: 500 }}>Start:</span>{" "}
            {Helper.formatDate(item.startDate)} {item.startTime}
          </div>
          <div>
            <span style={{ fontWeight: 500 }}>End:</span>{" "}
            {Helper.formatDate(item.endDate)} {item.endTime}
          </div>
        </div>
      ),
    },
    {
      title: "Status",
      key: "isParticipating",
      render: (item: any) => (
        <span
          style={{
            color: item.isParticipating ? "#10b981" : "#6b7280",
            fontWeight: 600,
            fontSize: "12px",
            background: item.isParticipating ? "#d1fae5" : "#f3f4f6",
            padding: "2px 8px",
            borderRadius: "12px",
          }}
        >
          {item.isActive ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (item: any) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            title="Join Deals"
            onClick={() => navigate(`/store/deals/${item.id}/products`)}
            width={140}
            height={32}
            styleButton="font-size: 12px; font-weight: 500; border-radius: 4px; background-color: #fff; color: #10b981; border: 1px solid #10b981;"
          />
        </div>
      ),
    },
  ];

  return (
    <Wrapper>
      <Header title="Available Deals" />
      <Table loading={loading} columns={columns} data={data} />
    </Wrapper>
  );
};

export default StoreDealsList;
